<div class="ds-paginator">
    <div class="ds-paginator-select-nav">
        <ds-button class="paginator-btn prev" [attr.button-type]="'button'" [attr.button-ui-variant]="'secondary'"
            [attr.button-size]="'medium'" [attr.button-icon]="'icon-chevron-left'" [attr.is-icon-button]="'true'"
            [attr.button-aria-label]="'paginazione.previousElement' | translate" [attr.is-disabled]="isPrevDisabled"
            [attr.animation-play]="false" [attr.has-aria-popup]='""' [attr.button-aria-controls]='""'
            [attr.button-aria-expanded]='""' (onClickEvent)="onPrev()">
        </ds-button>

        <ds-select-box   class="paginator-select" [attr.left-label]="'Pagina' | translate"
            [attr.right-label]="('di' | translate) + ' ' + totalPages"
            [attr.menu-placeholder]="'SelezionaPagina' | translate" [dataSelect]="dataSelect"
            (onOptionSelection)="onSelect($event)">
        </ds-select-box>

        <ds-button class="paginator-btn next" [attr.button-type]="'button'" [attr.button-ui-variant]="'secondary'"
            [attr.button-size]="'medium'" [attr.button-icon]="'icon-chevron-right'" [attr.is-icon-button]="'true'"
            [attr.button-aria-label]="'paginazione.nextElement' | translate" [attr.is-disabled]="isNextDisabled"
            [attr.animation-play]="false" [attr.has-aria-popup]='""' [attr.button-aria-controls]='""'
            [attr.button-aria-expanded]='""' (onClickEvent)="onNext()">
        </ds-button>
    </div>

</div>